import React from 'react'
import _ from 'lodash'
import { animateScroll as scroll } from 'react-scroll'
import { Modal, Spin } from 'antd'
import HalfPageModal from '../../components/UI/halfPageModal'
import Confirm from '../../components/UI/confirmModal'
import {
  getHealthStatus,
  saveScoreBulk,
  getRangeAgeScopes,
  createAR,
  getARDetail,
  createNote,
  updateNote,
  deleteNote,
  publish,
  notifyClient,
  update,
  getDynamicPart,
  createReferral,
  updateReferral,
  getClientProfileInfo,
  setDraft,
  getMetrics,
  getRecommendations
} from '../../api'
import Activities from '../../components/assessmentReview/comp/activities'
import { healthCardList as list } from '../../utils/constant'
import { getRole } from '../../utils'
import moment from 'moment'
import { ARDeckNotifyModal } from '../../components/assessmentReview/wrapper'

export const ARStatus = {
  published: 1,
  draft: 0
}

const ARDynamicSectionIndex = {
  ALL: 'all',
  LIFESTYLE: 1,
  HSD_SUMMARY: 2,
  AEROBIC_FITNESS: 3,
  BODY_COMP: 4,
  MUSCLE_FITNESS: 5,
  MOVEMENT_QUALITY: 6,
  BALANCE: 7,
  COGNITIV_EHEALTH: 8
}

const CommonSections = [
  ARDynamicSectionIndex.LIFESTYLE,
  ARDynamicSectionIndex.HSD_SUMMARY
]

const BasicDomainSections = [
  ARDynamicSectionIndex.AEROBIC_FITNESS,
  ARDynamicSectionIndex.BODY_COMP,
  ARDynamicSectionIndex.MUSCLE_FITNESS
]

export default (WrappedComponent) =>
  class Wrapper extends React.Component {
    state = {
      previous: { snapshot: {} },
      latest: { snapshot: {} },
      editingCount: 0,
      hideSection: [],
      currentLoadIndex: 0,
      needDynamicLoadSections: []
    }

    initial = async () => {
      const {
        match,
        getPerson,
        match: {
          params: { id },
          url
        },
        history,
        setBreadcrumb
      } = this.props
      const person = await getPerson()
      // const hash = match && match.params && match.params.hash
      const personId = match && match.params && match.params.personId
      const loginRole = getRole()
      if (id === 'new') {
        try {
          const ar = await createAR(person.id)
          history.replace(url.replace('new', ar.id))
        } catch (err) {
          console.error(err.message)
          this.setState({ createdFailed: err.message })
        }
      } else if (Number(id)) {
          const [arDetail, trendMetrics] = await Promise.all([
          getARDetail(id),
          getMetrics(person.id),
          getRangeAgeScopes()
        ])
        
        arDetail.detail = arDetail.detail || { hideSection: [] }
        let dynamicData, needDynamicLoadSections
        if (arDetail.status === ARStatus.published) {
          // published
          dynamicData = arDetail.detail.dynamicData
          needDynamicLoadSections = []
          const { latest_height, latest_weight } = arDetail.detail
          this.setState({
            latest_height,
            latest_weight,
            trendMetrics
          })
        } else {
          switch (person.profile.membership) {
            case 'basic':
              needDynamicLoadSections = _.concat(
                CommonSections,
                BasicDomainSections
              )
              break
            case 'premium':
              needDynamicLoadSections = _.concat(
                CommonSections,
                BasicDomainSections,
                [
                  ARDynamicSectionIndex.MOVEMENT_QUALITY,
                  ARDynamicSectionIndex.BALANCE,
                  ARDynamicSectionIndex.COGNITIV_EHEALTH
                ]
              )
              break
            default:
              needDynamicLoadSections = CommonSections
              break
          }

          const [data, information] = await Promise.all([
            getDynamicPart(person.id, needDynamicLoadSections[0], id),
            getClientProfileInfo(personId || (person && person.id))
          ])
          const { latest_height, latest_weight } = data
          const { device_info, residence } = information
          this.setState({
            device_info,
            residence,
            latest_height,
            latest_weight,
            loading: false
          })
          dynamicData = {
            ...data
          }
        }

        setBreadcrumb &&
          setBreadcrumb(person, {
            title: moment(arDetail.time_period).format('MMM YYYY')
          })

        const age_scope_def = (await getRangeAgeScopes()).age_scope
        const ageScopes = Object.entries(age_scope_def).map(([k, v]) => ({
          tag: k,
          scope: v.scope
        }))

        // Get assessment review data which includes copilot dashboard data
        try {
          const assessmentData = await getRecommendations(person.id, id)
          this.setState({
            person,
            arDetail: {
              ...arDetail,
              detail: {
                ...arDetail.detail,
                // Add new fields from AssessmentReviewResponse
                exerciseGapAnalysis: assessmentData.exercise_gap_analysis,
                nutritionGapAnalysis: assessmentData.nutrition_gap_analysis,
                sleepGapAnalysis: assessmentData.sleep_gap_analysis,
                intro: assessmentData.intro,
                nutritionProtocol: assessmentData.nutrition_protocol,
                sleepProtocol: assessmentData.sleep_protocol,
                exerciseProtocol: assessmentData.exercise_protocol,
                expectations: assessmentData.expectations,
                support: assessmentData.support,
                hideSection: arDetail.detail.hideSection || [],
              }
            },
            dynamicData,
            loginRole,
            ageScopes,
            needDynamicLoadSections,
            currentLoadIndex: 0,
            trendMetrics: trendMetrics.filter(
              (item) => item.category === 'Blood Metrics'
            ),
            // Exercise recommendation plots
            exerciseRecommendationPlots: {
              weekly_schedule: assessmentData.weekly_schedule,
              hsd_intensity: assessmentData.hsd_intensity
            },
            copilotDashboard: {
              activities: assessmentData.activities,
              allActivities: assessmentData.all_activities,
              heartRateZones: assessmentData.heart_rate_zones
            }
          })
        } catch (error) {
          console.error('Failed to fetch assessment data:', error)
          this.setState({ 
            exerciseRecommendationPlots: {
              weekly_schedule: null,
              hsd_intensity: null
            },
            copilotDashboard: {
              activities: null,
              allActivities: null,
              heartRateZones: null
            }
          })
        }
      }
    }

    next = async () => {
      const {
        match: {
          params: { id }
        }
      } = this.props
      let {
        needDynamicLoadSections,
        currentLoadIndex,
        dynamicData,
        arDetail
      } = this.state
      const person = await this.props.getPerson()
      let result
      if (needDynamicLoadSections.length > currentLoadIndex + 1) {
        result = await getDynamicPart(
          person.id,
          needDynamicLoadSections[currentLoadIndex + 1],
          id
        )
        const notes = _.get(result, 'notes')
        if (notes) {
          arDetail.notes = arDetail.notes.concat(notes)
          delete result.notes
        }
        dynamicData = _.assign(dynamicData, {
          ...result
        })
        currentLoadIndex++
      } else {
        return dynamicData
      }

      this.setState({ currentLoadIndex, dynamicData, arDetail })
      return dynamicData
    }

    handleConfirmPublish = async () => {
      this.setState({ isShowPublishConfirm: false, publishLoading: true })
      const { history } = this.props
      const {
        arDetail,
        person,
        device_info,
        residence,
        latest_height,
        latest_weight,
        currentLoadIndex,
        needDynamicLoadSections
      } = this.state
      let dynamicData = this.state.dynamicData

      if (needDynamicLoadSections.length > currentLoadIndex + 1) {
        for (
          let i = currentLoadIndex;
          i < needDynamicLoadSections.length;
          i++
        ) {
          dynamicData = await this.next()
        }
      }
      await update({
        id: arDetail.id,
        detail: _.assign(arDetail.detail || {}, {
          dynamicData,
          device_info,
          residence,
          latest_height,
          latest_weight
        })
      })
      await publish(arDetail.id)
      arDetail.status = ARStatus.published
      this.setState({ publishLoading: false, arDetail })
      /* transition： hide phase 2  */
      // this.setState({ isShowNotifyModal: true })
      const path = `/client/${person.id}/detail/ass-report/preview/${arDetail.id}`
      const { protocol, hostname, port } = window.location
      window.open(
        `${protocol}//${hostname}${port ? ':' + port : ''}${path}?savePDF=true`
      )
      history.push(path)
    }

    cancelNotify = () => {
      const { history } = this.props
      const { person } = this.state
      this.setState({ isShowNotifyModal: false })
      history.push(`/client/${person.id}/detail/ass-report`)
    }

    handleNotify = async (message) => {
      const { history } = this.props
      const { arDetail, person } = this.state
      await notifyClient(arDetail.id, message)
      history.push(`/client/${person.id}/detail/ass-report`)
    }

    handlePreview = () => {
      const { match, history } = this.props
      history.push(match.url.replace('draft', 'preview'))
    }

    handleSave = async (params, target) => {
      const { arDetail, person } = this.state
      if (!params) {
        // draft
        let url = `/client/${person.id}/detail/ass-report`
        if (target === 'edit') {
          url = `/client/${person.id}/detail/ass-report/draft/${arDetail.id}`
        }
        setTimeout(() => {
          this.props.history.push(url)
        }, 1000)
      } else {
        arDetail.detail = arDetail.detail || {}
        if (params.detail) {
          params.detail = _.assign(arDetail.detail, params.detail)
        }
        // params
        await update({
          id: arDetail.id,
          ...params
        })
      }
    }

    handleToSetDraft = async () => {
      const { arDetail, person } = this.state
      Modal.confirm({
        title: 'Are you sure?',
        afterClose: () => {
          const url = `/client/${person.id}/detail/ass-report/draft/${arDetail.id}`
          setTimeout(() => {
            this.props.history.push(url)
          }, 1000)
        },
        onOk() {
          return setDraft(arDetail.id)
        }
      })
    }

    handleUpdateReferral = async (referralId, params) => {
      let itemId = null
      if (referralId) {
        itemId = referralId
        await updateReferral(referralId, params)
      } else {
        const { id } = await createReferral(this.state.arDetail.id, params)
        itemId = id
      }
      const id = Number(this.props.match.params.id)
      const arDetail = await getARDetail(id)
      this.setState({ arDetail })
      return _.find(arDetail.referrals, { id: itemId })
    }

    handleCommendDelete = async (id) => {
      const { arDetail } = this.state
      await deleteNote(id)
      arDetail.notes = arDetail.notes.filter((item) => item.id !== id)
      this.setState({ arDetail })
    }

    handleCommendSave = async (value, pillar, status) => {
      const { arDetail } = this.state
      let target = arDetail.notes.find((item) => item.pillar === pillar)
      if (status === 'delete') {
        return this.handleCommendDelete(target.id)
      }
      const params = {
        pillar,
        memo: value
      }
      if (target) {
        await updateNote(target.id, params)
        target = _.assign(target, params)
      } else {
        const { id } = await createNote(arDetail.id, params)
        arDetail.notes.push({
          id,
          ...params
        })
      }
      this.setState({ arDetail })
    }

    HandleSaveScore = async (details) => {
      const person_id = this.state.person.id
      await saveScoreBulk({
        details,
        person_id
      })
      const {
        results,
        latest_bmi,
        latest_height,
        latest_weight
      } = await getHealthStatus(person_id)
      this.setState({
        latest: results.filter((item) => item.graph_type === 'latest')[0],
        previous: results.filter((item) => item.graph_type === 'previous')[0],
        latest_bmi,
        latest_height,
        latest_weight
      })
    }

    jumpToDataset = (type) => {
      const {
        history,
        match: { url }
      } = this.props
      const types = {
        bio_marker: 'blood-test',
        body_comp: 'body-comp',
        lifestyle_assessment: 'life-style',
        cardiorespiratory: 'cardiorespiratory',
        cognitive_health: 'cognitive-health',
        physical_assessment: 'physical'
      }

      const path = types[type]

      if (path) {
        history.push(`${url.split('detail/')[0]}detail/${path}`)
      }
    }

    updateEditingCount = (increment) => {
      const { editingCount } = this.state
      this.setState({ editingCount: editingCount + increment })
    }

    hideSectionHandle = (section, oprType) => {
      let { hideSection } = this.state
      if (oprType === 'show') {
        _.remove(hideSection, (item) => item === section)
      } else {
        hideSection.push(section)
      }
      this.setState({ hideSection })
      this.handleSave({
        detail: {
          hideSection
        }
      })
    }

    componentDidMount() {
      this.initial()
    }

    componentDidUpdate(prevProps) {
      if (this.props.match.params.id !== prevProps.match.params.id) {
        this.initial()
      }
    }

    render() {
      const {
        isShowActivity,
        isShowNotifyModal,
        isShowPublishConfirm
      } = this.state
      const {
        match: {
          params: { id }
        }
      } = this.props
      const childProps = {
        ...this.state,
        list: _.cloneDeep(list),
        jumpToDataset: this.jumpToDataset, // maybe preview
        routeTypes:
          'bio_marker,body_comp,lifestyle_assessment,cardiorespiratory,cognitive_health,physical_assessment',
        handlePublish: () => this.setState({ isShowPublishConfirm: true }),
        handlePreview: this.handlePreview,
        handleSave: this.handleSave,
        handleToSetDraft: this.handleToSetDraft,
        handleCommendSave: this.handleCommendSave,
        HandleSaveScore: this.HandleSaveScore,
        updateEditingCount: this.updateEditingCount,
        showActivity: () => {
          this.setState({ isShowActivity: true })
          scroll.scrollToTop({ ignoreCancelEvents: true, smooth: true })
        },
        handleNotify: () => this.setState({ isShowNotifyModal: true }),
        next: this.next,
        hideSectionHandle: this.hideSectionHandle,
        onUpdateReferral: this.handleUpdateReferral,
        updateArDetail: (arDetail) => this.setState({ arDetail }),
        trendMetrics: this.state.trendMetrics 
      }
      // handleConfirmPublish
      return (
        <Spin spinning={!!this.state.publishLoading}>
          <WrappedComponent {...childProps} {...this.props} />
          {isShowActivity && (
            <HalfPageModal
              position="right"
              close={() => this.setState({ isShowActivity: false })}
              title="Activity"
            >
              <Activities id={id} />
            </HalfPageModal>
          )}
          {isShowNotifyModal && (
            <ARDeckNotifyModal
              onCancel={this.cancelNotify}
              handleNotify={this.handleNotify}
            />
          )}
          {isShowPublishConfirm && (
            <Confirm
              {...{
                modalWidth: 600,
                onCancel: () => this.setState({ isShowPublishConfirm: false }),
                title: 'Publish Comprehensive Report confirmation',
                description:
                  "Are you sure you want to publish and upload this PDF to this client's Files?",
                confirmText: 'PUBLISH',
                onConfirm: this.handleConfirmPublish
              }}
            />
          )}
        </Spin>
      )
    }
  }
